import { Form, Input } from 'antd';
import {
  AppPasswordInput,
  getAppPasswordRules,
} from '../shared/AppPasswordInput';
import styles from './style.module.css';
import passwordStyles from './SIPAccountBasicFields.module.css';

type BasicFieldsProps = {
  readonly isCreateMode: boolean;
  readonly serverRequiredVisible: boolean;
};

export const SIPAccountBasicFields = ({
  isCreateMode,
  serverRequiredVisible,
}: BasicFieldsProps) => {
  if (!isCreateMode) {
    return (
      <div className={styles.panelContent}>
        <div className={passwordStyles.defaultFieldsGrid}>
          <Form.Item name="name" label="Название" className={styles.fieldItem}>
            <Input placeholder="Например, основной SIP" />
          </Form.Item>
          <Form.Item name="server" label="Адрес" className={styles.fieldItem}>
            <Input disabled readOnly />
          </Form.Item>
        </div>
      </div>
    );
  }
  return (
    <div className={styles.panelContent}>
      <div className={styles.formGrid}>
        <Form.Item name="name" label="Название" className={styles.fieldItem}>
          <Input placeholder="Например, основной SIP" />
        </Form.Item>
        <Form.Item
          name="username"
          label="Имя пользователя"
          className={styles.fieldItem}
        >
          <Input placeholder="Логин SIP-аккаунта" />
        </Form.Item>
        <div className={passwordStyles.passwordField}>
          <Form.Item
            name="password"
            label="Пароль"
            className={styles.fieldItem}
            hasFeedback
            rules={[
              { required: true, message: 'Необходимо указать пароль' },
              ...getAppPasswordRules(),
            ]}
          >
            <AppPasswordInput
              placeholder="Пароль SIP-аккаунта"
              showHint
              hintClassName={passwordStyles.passwordHint}
            />
          </Form.Item>
        </div>
        <Form.Item
          name="server"
          label="Адрес сервера"
          className={styles.fieldItem}
          validateStatus={serverRequiredVisible ? 'error' : undefined}
          help={
            serverRequiredVisible
              ? 'Необходимо указать адрес сервера'
              : undefined
          }
          rules={[
            {
              required: true,
              message: 'Необходимо указать адрес сервера',
            },
          ]}
        >
          <Input placeholder="sip.example.com" />
        </Form.Item>
        <Form.Item
          name="prefix"
          label="Префикс вызова"
          className={styles.fieldItem}
        >
          <Input placeholder="7" />
        </Form.Item>
      </div>
    </div>
  );
};
